import { useMemo, useState } from 'react';

/**
 * Hook to use references as part of the react lifecycle
 */
export const useReferenceLoader = <T extends HTMLElement = HTMLElement>(): ReferenceLoader<T> => {
	const [ref, setRef] = useState<T | null>(null);

	return useMemo(
		() => ({
			setRef,
			ref,
		}),
		[setRef, ref],
	);
};

export type ReferenceLoader<T extends HTMLElement = HTMLElement> = {
	setRef: (ref: T | null) => void;
	ref: T | null;
};
